import $ from 'Vendor/jquery'
import Logger from 'Vendor/@openmind/litelog'

import Marker from '../../marker'


if( window.BMapLib && window.BMapLib.MarkerClusterer &&  window.BMapLib.TextIconOverlay){
  /* Overrides `addMarker` method for binding cluster to Marker */
  let _addMarker = window.BMapLib.MarkerClusterer.prototype.addMarker;
  window.BMapLib.MarkerClusterer.prototype.addMarker = function(marker) {
    let result = _addMarker.apply(this, arguments);

    // Bind `cluster` if marker is not shown in map
    marker._cluster = this; //marker.getMap() == null ? this : null;

    return result;
  };

  /* Overrides `addMarker` method for binding cluster to Marker */
  let _addMarkers = window.BMapLib.MarkerClusterer.prototype.addMarkers;
  window.BMapLib.MarkerClusterer.prototype.addMarkers = function(markers) {
    let result = _addMarkers.apply(this, arguments);

    for(const m of markers){
      // Bind `cluster` if marker is not shown in map
      m._cluster = this; //marker.getMap() == null ? this : null;
    }
    return result;
  };

  /* Sets the correct image size to background */
  let _buildCssText = window.BMapLib.TextIconOverlay.prototype._buildCssText;
  window.BMapLib.TextIconOverlay.prototype._buildCssText = function(g) {
    let str = _buildCssText.apply( this, arguments );
    let style = [str + ";"];
    style.push(
        "text-indent: 100%; white-space: nowrap; overflow: hidden;"
    );
    return style.join("");
  };

  let _initialize = window.BMapLib.TextIconOverlay.prototype.initialize;
  window.BMapLib.TextIconOverlay.prototype.initialize = function(g) {
    let _domElement = _initialize.apply( this, arguments );
    this._domElement.classList.add("bmap-cluster")
    return _domElement;
  };
}

const Log = new Logger("StoreLocator/BaiduMarker");


class BaiduMarker extends Marker {

  constructor(position, data, map) {

    super( data );

    position = position instanceof window.BMap.Point ? position : new window.BMap.Point( position.coordinates[0],position.coordinates[1] );

    this.marker = new window.BMap.Marker(position,{
      title: data['displayName']
    });

    this.map = map;

    return this;
  }


  /**
   * @Override
   */
  set map(map){
    //debugger;
    /*if(map){
      map.Map.addOverlay(this.marker)
    }else if(!map && this.__map__){
      this.__map__.Map.removeOverlay(this.marker)
    }*/
    this.__map__ = map;
    return this;
  };

  /**
   * @Override
   */
  get map(){
    return this.__map__;
  };


  /**
   * @Override
   */
  get storeData() {
    return this.data;
  }

  /**
   * @Override
   */
  get coordinates() {
    //debugger;
    const {lat,lng} = this.marker.getPosition();
    return { lat, lng};
  }


  /**
   * @Override
   */
  set image({Url,Size}) {

    this.marker.setIcon(
        new BMap.Icon(
            Url,
            new window.BMap.Size(Size.w*1.2, Size.h*1.2),
            {
              anchor: new BMap.Size(0, 0),
              imageSize: new window.BMap.Size(Size.w, Size.h)
            }
        )
    );

    return this;
  }


  /**
   * @Override
   */
  get image() {
    //debugger;
    let icon = this.marker.getIcon();
    return {
      Url: icon.imageUrl,
      Size: {w:icon.imageSize.width, h:icon.imageSize.height}
    };
  }

  /**
   * @Override
   */
  set label({text,color,fontSize}) {
    //debugger;

    const mrkLabel = this.marker.getLabel();
    if(mrkLabel){
      mrkLabel.remove();
    }

    //>9 -> 6
    //<=9 -> 9
    //>99 -> 3
    const marginLeft = text<=9?9:text>99?3:6;
    const label = new BMap.Label(text, {offset: new BMap.Size(marginLeft, 4) });
    label.setStyle({'backgroundColor':'inherit', border:'none',color,fontSize})
    this.marker.setLabel(label)
    return this;
  }

  /**
   * @Override
   */
  get label() {
    //debugger;
    return this.marker.getLabel();
  }

  /**
   * @Override
   */
  set title(text) {
    //debugger;
    this.marker.setTitle(text);
    return this;
  }


  /**
   * @Override
   */
  get title() {
    //debugger;
    return this.marker.getTitle();
  }

  /**
   * @Override
   */
  highlight(highlight,icon) {
    if(icon){
      this.image = icon;
    }
    const marker = this.marker;
    const label = marker.getLabel();
    if(label){
      const originalZIndex = $(label.ca).parent().data("original-z-index") || $(label.ca).parent().css("z-index");
      if(highlight) {
        $(label.ca).parent().data(
            "original-z-index",
            originalZIndex
        )
      }
      $(label.ca).parent().css( "z-index", highlight ? 999 : originalZIndex );
    }
    return this;
  }

  /**
   * @Override
   */
  hide() {
    //debugger;
    this.map.removeOverlay(  this.marker  );
    if ( this.cluster ) {
      this.cluster.removeOverlay( this.marker );
    }
  }

  /**
   * @Override
   */
  show() {
    //debugger;
    // we need to `remove marker from cluster` before re-adding it to cluster (in case of)
    this.map.addOverlay(  this.marker  );
    if ( this.cluster ) {
      this.cluster.addOverlay( this.marker );
    }
  }

  /**
   * @Override
   */
  get cluster() {
    return this.marker._cluster;
  }

  /**
   * @Override
   */
  highlightCluster(hover) {
    let cluster = this.cluster;

    if(!cluster) return;

    cluster=(cluster._clusters.filter(c=>c.isMarkerInCluster(this.marker))||[])[0];

    if ( cluster ) {
      const {_domElement}=cluster._clusterMarker;
      const marker = $(this.marker.ca)
      const markerIsOutsideOfTheCluster=marker && marker.length>0
      if(hover && !markerIsOutsideOfTheCluster){
        $(_domElement).addClass(`bmap-cluster-hov`);
      }else{
        $(_domElement).removeClass(`bmap-cluster-hov`);
      }
    } else {
      Log.info("This marker seems to be in map, not in cluster");
    }
  }

  /**
   * @Override
   */
  on(ev, fn){
    this.marker.addEventListener(ev, fn);
    return this;
  };

  /**
   * @Override
   */
  off(ev){
    if ( typeof ev == 'string' ) {
      const eventName = "on"+ev;
      const eventsListeners = this.Map.Li || {};
      const eventCallbacks = eventsListeners[eventName] || [];
      for(const e in eventCallbacks){
        this.marker.removeEventListener(ev,eventCallbacks[e]);
      }
    } else {
      this.marker.removeEventListener(Object.keys(ev.nl)[0],ev);
    }
    return this;
  };

  /**
   * @Override
   */
  trigger(ev) {
    this.marker.dispatchEvent(ev);
    return this;
  };


  clone() {
    return new BaiduMarker( this.coordinates, this.data );
  };


}

export default BaiduMarker;

















